import { BlockHeading } from "components/landing-pages/BlockHeading";
import { Video } from "components/videos/Video";
import { VideoBlock } from "dtos/content/landing-pages/VideoBlock";

export const VideoBlockDisplay = (props: { block: VideoBlock }) => {
    const { block } = props;
    const { content, videoId, actionText, actionUrl, actionNewTab, heading, videoSide } = block;

    const videoClass = videoSide === "left" ? "order-lg-2" : "order-lg-3";
    const contentClass = videoSide === "left" ? "order-lg-3" : "order-lg-2";

    return (
        <div className="grid">
            {heading && (
                <div className="g-col-12">
                    <BlockHeading block={block} />
                </div>
            )}

            <div className={`g-col-12 g-col-lg-6 order-2 align-self-center ${videoClass}`}>
                <Video id={videoId} />
            </div>

            <div className={`g-col-12 g-col-lg-6 order-3 align-self-center ${contentClass}`}>
                <div className="vstack gap-4">
                    <div className="content-block vstack gap-4" dangerouslySetInnerHTML={{ __html: content }}></div>

                    {actionText && actionUrl && (
                        <div>
                            <a className="btn btn-primary" href={actionUrl} target={actionNewTab ? "_blank" : "_self"}>
                                {actionText}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
